import { Component } from 'react';
import { createUploadProgressHandler, UploadProgressHandler } from '../../helpers/uploadProgressHandler';
import uploader from '../../helpers/callAudioUploader';
import { ProgressBar } from '../ProgressBar';
import { CallAudioUploadCallIdentifier } from '../../store/state/callAudioUploadState';
import { doCallAudioIdentifiersMatch } from '../../helpers/jobHelpers';

export class JobAudioUploadProgressBar extends Component<Props, State> {
	private unsubscribe: (() => void) | null = null;
	private handler: UploadProgressHandler = createUploadProgressHandler();
	
	componentDidMount() {
		this.unsubscribe = uploader.subscribeToProgress((event) => {
			if (event.jobId === this.props.jobId && doCallAudioIdentifiersMatch(event.callIdentifier, this.props.callIdentifier, true)) {
				this.handler.handleUploadProgress(event.progress);
			}
		});
	}
	
	componentWillUnmount() {
		if (this.unsubscribe) {
			this.unsubscribe();
		}
	}
	
	render() {
		return (
			<ProgressBar estimatedDuration={10000} 
						 isComplete={this.props.isComplete}
						 barSize="small"
						 uploadProgressNotifier={this.handler} />
		)
	}
}

interface Props {
    jobId: number;
    callIdentifier: CallAudioUploadCallIdentifier;
    isComplete: boolean;
}

interface State {}